import { useModal } from 'common/hooks/useModal';

import { ImportBudgetModalContainer } from '../components/ImportBudgetModal';
import { DeleteBudgetaryExerciseModalContainer } from '../containers/DeleteBudgetaryExerciseModalContainer';
import { EditBudgetaryExerciseModalContainer } from '../containers/EditBudgetaryExerciseModalContainer';
import { type BudgetaryExercise } from '../models/budgetaryExercise';

export const useBudgetaryExerciseModals = (
  budgetaryExercise: BudgetaryExercise,
) => {
  const [
    budgetaryExerciseEditionModal,
    showBudgetaryExerciseEditionModal,
    hideBudgetaryExerciseEditionModal,
  ] = useModal(
    ({
      budgetaryExerciseToEdit,
    }: {
      budgetaryExerciseToEdit: BudgetaryExercise;
    }) => {
      if (!budgetaryExerciseToEdit) {
        return <></>;
      }
      return (
        <EditBudgetaryExerciseModalContainer
          budgetaryExercise={budgetaryExerciseToEdit}
          onHide={() => hideBudgetaryExerciseEditionModal()}
        />
      );
    },
  );

  const [
    budgetaryExerciseDeletionConfirmationModal,
    showBudgetaryExerciseDeletionConfirmationModal,
    hideBudgetaryExerciseDeletionConfirmationModal,
  ] = useModal(
    ({
      budgetaryExerciseToDelete,
    }: {
      budgetaryExerciseToDelete: BudgetaryExercise;
    }) => {
      if (!budgetaryExerciseToDelete) {
        return <></>;
      }
      return (
        <DeleteBudgetaryExerciseModalContainer
          budgetaryExercise={budgetaryExerciseToDelete}
          onHide={() => {
            hideBudgetaryExerciseDeletionConfirmationModal();
          }}
        />
      );
    },
  );

  const [
    editBudgetExpenseCategoriesModal,
    showEditBudgetExpenseCategoriesModal,
    hideEditBudgetExpenseCategoriesModal,
  ] = useModal(
    ({
      budgetaryExerciseToEdit,
    }: {
      budgetaryExerciseToEdit: BudgetaryExercise;
    }) => {
      if (!budgetaryExerciseToEdit) {
        return <></>;
      }
      return (
        <ImportBudgetModalContainer
          type="edit"
          onSuccess={() => hideEditBudgetExpenseCategoriesModal()}
          budgetaryExerciseId={budgetaryExerciseToEdit.id}
          onExit={() => hideEditBudgetExpenseCategoriesModal()}
        />
      );
    },
  );

  const modals = {
    budgetaryExerciseEditionModal,
    budgetaryExerciseDeletionConfirmationModal,
    editBudgetExpenseCategoriesModal,
  };

  const handlers = {
    showEdit: () =>
      showBudgetaryExerciseEditionModal({
        budgetaryExerciseToEdit: budgetaryExercise,
      }),
    showDelete: () =>
      showBudgetaryExerciseDeletionConfirmationModal({
        budgetaryExerciseToDelete: budgetaryExercise,
      }),
    showUpdateBudgets: () =>
      showEditBudgetExpenseCategoriesModal({
        budgetaryExerciseToEdit: budgetaryExercise,
      }),
  };

  return { modals, handlers };
};
